// =============================================================================
// Cheng Hua Supermart — front-end behaviour.
//
// Each module restores one piece of the mockup's interactivity. Everything the
// modules touch is already rendered and styled by PHP and SCSS, so the page is
// usable before this file runs: links navigate, the filter form submits, and
// "Add to Cart" is a real WooCommerce URL. These only make it feel instant.
// =============================================================================

import initNav from "./modules/nav.js";
import initCart from "./modules/cart.js";
import initShopFilters from "./modules/shop-filters.js";
import initContactForm from "./modules/contact.js";
import initSliders from "./modules/slider.js";

function boot() {
	initNav();
	initCart();
	initShopFilters();
	initContactForm();
	initSliders();
}

// The bundle is a deferred module, so the document is normally parsed by now.
// The readyState check covers the case where it is not.
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", boot);
} else {
	boot();
}
